import React from 'react';
import { Typography } from '@deeptrue-frontend/ui';
import { useIntl } from 'react-intl';
import styled from 'styled-components/macro';
import { ReportType, SubgroupType } from '../types';
import { translateGroupName } from '../utils';

const OlSticky = styled.ol<{ padding?: string }>`
  list-style-type: none;
  position: sticky;
  position: -webkit-sticky;
  max-height: 100vh;
  overflow-y: auto;
  top: 3rem;
  padding: ${({ padding }) => (padding ? padding : '1rem 0')};
  margin: 0;
`;

const Ol = styled.ol<{ padding?: string }>`
  list-style-type: none;
  position: sticky;
  position: -webkit-sticky;
  top: 3rem;
  padding: ${({ padding }) => (padding ? padding : '1rem 0')};
  margin: 0;
`;

const Li = styled.li<{ withBorder?: boolean }>`
  padding: 0;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  border-bottom: ${({ withBorder }) =>
    withBorder ? '1px solid #E6E6E5' : 'none'};
`;

const StyledListText = styled(Typography)<{
  isActive: boolean;
}>`
  padding: 0.9rem 2rem;
  font-size: 0.875rem;

  ${({ isActive }) =>
    isActive &&
    `
  background-color:#F6F9FE;
`}
`;

const GroupTitle = styled(Typography)<{
  isActive: boolean;
}>`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.875rem;

  ${({ isActive }) =>
    isActive &&
    `
    background-color:#F6F9FE;
`}
  padding: 0.9rem 2rem;
`;

const SatisfactionNotes = styled.div``;

interface TabType {
  value: number;
  name: string;
}

interface Props {
  reportsLegend: Array<ReportType>;
  setSection: (section: any) => void;
  selectedSection: string | undefined;
}

const Legend = ({ reportsLegend, setSection, selectedSection }: Props) => {
  const { locale } = useIntl();
  return (
    <SatisfactionNotes>
      <OlSticky>
        {reportsLegend.map((group: ReportType, index: number) => {
          const { group_name, subgroups } = group;
          const groupTitle = translateGroupName(group_name, locale);
          const isGroupSelected = !!(
            selectedSection && selectedSection === groupTitle
          );

          return (
            <Li
              key={index}
              withBorder
              onClick={(e: any) => {
                e.stopPropagation();
                setSection(groupTitle);
              }}
            >
              <GroupTitle isActive={isGroupSelected} color="#253858">
                {groupTitle}
              </GroupTitle>
              {subgroups && (
                <Ol padding="0">
                  {subgroups.map((subgroup: SubgroupType, idx: number) => {
                    const subgroupTitle = translateGroupName(
                      subgroup.name,
                      locale
                    );
                    const isActive =
                      `${groupTitle}-${subgroupTitle}` === selectedSection;
                    return (
                      <Li
                        key={`${subgroupTitle}-${idx}`}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setSection(`${groupTitle}-${subgroupTitle}`);
                        }}
                      >
                        <StyledListText color="#253858" isActive={isActive}>
                          {subgroupTitle}
                        </StyledListText>
                      </Li>
                    );
                  })}
                </Ol>
              )}
            </Li>
          );
        })}
      </OlSticky>
    </SatisfactionNotes>
  );
};

export default Legend;
